import { render, staticRenderFns } from "./HealthScheme.vue?vue&type=template&id=e7189b3c&scoped=true&"
import script from "./HealthScheme.vue?vue&type=script&lang=js&"
export * from "./HealthScheme.vue?vue&type=script&lang=js&"
import style0 from "./HealthScheme.vue?vue&type=style&index=0&id=e7189b3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7189b3c",
  null
  
)

export default component.exports